import React, { useEffect, useState } from 'react';
import { fetchActiveVagas } from '../api';
import VagaCard from './VagaCard';

export default function ActiveVagas({ showHeader = true }) {
  const [vagas, setVagas] = useState([]);

  async function load() {
    const data = await fetchActiveVagas();
    setVagas(data);
  }

  useEffect(() => { load(); }, []);

  return (
    <div>
      <div className="row">
        {(vagas ?? []).map(v => (
          <div key={v.id} className="col-md-4 col-xs-12 mb-3">
            <VagaCard vaga={v} />
          </div>
        ))}
      </div>
    </div>
  );
}
